// FAQ accordion: toggle classes only. Styling/animation is handled in SCSS.
// Requirements:
// - Event delegation on .p_faq_list
// - Determine target from clicked element via ancestors/descendants (closest)
// - Toggle .is-open on the corresponding .p_faq_item
// - No inline styles manipulation

document.addEventListener("DOMContentLoaded", () => {
  const lists = document.querySelectorAll(".p_faq_list");
  if (!lists.length) return;

  lists.forEach((list) => {
    // Open the first item by default on initial load
    const firstItem = list.querySelector(".p_faq_item");
    if (firstItem) firstItem.classList.add("is-open");

    list.addEventListener("click", (e) => {
      const target = e.target;
      // Only react when clicking within a question block
      const q = target.closest(".faq_q");
      if (!q || !list.contains(q)) return;

      const item = q.closest(".p_faq_item");
      if (!item) return;

      item.classList.toggle("is-open");
    });
  });
});
